import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { IonSelect } from '@ionic/angular';

@Component({
    selector: 'base-select',
    templateUrl: './base-select.component.html',
    styleUrls: ['./base-select.component.scss'],
})
export class BaseSelectComponent {

    @Input('model') model?: any = null;
    @Input('items') items: any[] = [];

    @Input('show') show?: boolean = true;
    @Input('disabled') disabled?: boolean = false;

    @Input('itemValueField') itemValueField?: string|null = null;
    @Input('itemTextField') itemTextField?: string|null = null;
    @Input('label') label?: string = 'Selecione';
    @Input('okText') okText?: string = 'Ok';
    @Input('cancelText') cancelText?: string = 'Cancelar';
    @Input('placeholder') placeholder?: string = 'Selecione...';

    @Output('onChange') onChange = new EventEmitter<any>();
    @Output() modelChange: EventEmitter<any> = new EventEmitter<any>();

    @ViewChild('ionSelect') public ionSelect: IonSelect;

    public change(event: any): void {
        this.modelChange.emit(event);
        this.onChange.emit(event);
    }

    public open(): void {
        this.ionSelect.open();
    }
}
